import { createSelector } from '@reduxjs/toolkit';

import { Bundle } from '@paragon/contract-library';
import { assertExhaustiveSwitch, sortBy } from '@paragon/utilities';

import { RootState } from '../store';
import { getBundlesForActiveProductionGroupGuid } from './bundles';
import { getWarningsByBundleGuid } from './getWarningsByBundleGuid';

export const getBundlesForBundleList = createSelector(
  (state: RootState) => state.batchesAndBundlesTab.bundlesToShow,
  getBundlesForActiveProductionGroupGuid,
  getWarningsByBundleGuid,

  (bundlesToShow, bundlesForActiveProductionGroupGuid, warningsByBundleGuid) => {
    if (bundlesForActiveProductionGroupGuid === null) return null;
    let bundleList: Bundle[];
    switch (bundlesToShow) {
      case 'All':
        bundleList = [...bundlesForActiveProductionGroupGuid];
        break;
      case 'BundlesWithWarnings':
        bundleList = [...bundlesForActiveProductionGroupGuid]?.filter(
          (bundle) => warningsByBundleGuid[bundle.guid].length > 0,
        );
        break;
      default:
        assertExhaustiveSwitch(bundlesToShow);
    }
    return sortBy(bundleList, (bundle) => bundle.id, 'desc');
  },
);
